import { Dialog, DialogContent } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { getDefaultCollectionName } from "../utils";
import { createMiqCollection, updateCurrentUser } from "wasp/client/operations";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useQuery } from "wasp/client/operations";
import { getAllCollectionsOfUser } from "wasp/client/operations";
import { Loader2 } from "lucide-react";
import { GetAllCollectionsOfUserOutput } from "../admin/dashboards/operations";
import { useTranslation } from "../i18n/hooks";

type SwitchStoreDialogProps = {
  open: boolean;
  onOpenChange: (arg: boolean) => void;
};

const SwitchStoreDialog = ({open, onOpenChange}: SwitchStoreDialogProps) => {
  const { t } = useTranslation();
  const { currentUser, currentCollection } = useSelector((state: RootState) => state.user);
  const { data: collections, isLoading: collectionsLoading } = useQuery(
    getAllCollectionsOfUser
  );

  const currentCollectionId = currentCollection?.collection?.id;
  
  const handleSwitch = async (collectionId: string) => {
    try {
      await updateCurrentUser({ currentCollectionId: collectionId });
      //refresh page
      window.location.reload();
      onOpenChange(false);
    } catch (error) {
      console.error(t('switchStoreDialog.switch_failed'), error);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="p-6">
        <h1 className="text-lg font-semibold mb-4 text-slate-800">{t('switchStoreDialog.switch_store')}</h1>
        <div>
          {collectionsLoading ? (
            <div className="flex justify-center p-4">
              <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
            </div>
          ) : (
            <div className="max-h-96 overflow-y-auto border rounded-md bg-slate-100 p-2">
              <div className="flex flex-col gap-2">
                {(collections as GetAllCollectionsOfUserOutput[]).map((collection) => (
                  <div
                    className={`rounded-lg p-3 flex items-center justify-between ${
                      currentCollectionId === collection.id 
                        ? 'bg-blue-50 border-2 border-blue-200'
                        : 'bg-white hover:bg-slate-50 border border-slate-200'
                    }`}
                    key={collection.id}
                  >
                    <div className="flex items-center gap-2">
                      <div className="font-semibold text-sm text-slate-700">
                        {collection.name}
                      </div>
                      {currentCollectionId === collection.id && (
                        <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                          {t('switchStoreDialog.current')}
                        </span>
                      )}
                      {collection?.miqImportMethod === 'shopify' && (
                        <Badge color="blue" variant="outline">{t('switchStoreDialog.shopify')}</Badge>
                      )}
                      {collection?.miqImportMethod === 'excel' && (
                        <Badge color="green" variant="outline">{t('switchStoreDialog.excel')}</Badge>
                      )}
                    </div>
                    <Button
                      variant="ghost"
                      className="text-sm text-blue-600 hover:bg-blue-50 hover:text-blue-700"
                      disabled={currentCollectionId === collection.id}
                      onClick={() => handleSwitch(collection.id)}
                    >
                      {currentCollectionId === collection.id ? t('switchStoreDialog.active') : t('switchStoreDialog.switch')}
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SwitchStoreDialog;